/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   24/11/2016 3:43 PM
 * @Email:  alex@yuion.net
 * @Filename: step.component.ts
 * @Last modified by:   alex.sorafumo
 * @Last modified time: 20/01/2017 3:45 PM
 */

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output} from '@angular/core';

import { StepperComponent } from './stepper.component';
import { BaseWidgetComponent } from '../../../shared/base.component';

@Component({
    selector: 'stepper-step',
    template: `<!--
@Author: Alex Sorafumo <Yuion>
@Date:   24/11/2016 3:43 PM
@Email:  alex@yuion.net
@Filename: step.template.html
@Last modified by:   Yuion
@Last modified time: 15/12/2016 11:32 AM
-->

<div [class]="'stepper-step ' + name" [@show]="model.direction" *ngIf="state === 'active'" widget>
    <div class="heading">
        <div class="icon"></div>
        <div class="text">{{heading}}</div>
    </div>
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
`,
    styles: [`.stepper-step{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:left;width:100%}.heading{font-size:.6em;text-align:center;margin-bottom:1em}`],
    animations: [
        trigger('show', [
            transition('void => horz', [
                style({ opacity: 0, left: 0, top: 0, position: 'absolute', transform: 'translateX(100%)' }),
                animate(300, style({ opacity: 1, left: 0, top: 0, position: 'absolute', transform: 'translateX(0%)' }))
            ]),
            transition('horz => void', [
                style({ opacity: 1, left: 0, top: 0, position: 'absolute', transform: 'translateX(0%)' }),
                animate(300, style({ opacity: 0, left: 0, top: 0, position: 'absolute', transform: 'translateX(-100%)' }))
            ]),
            transition('void => horz-reverse', [
                style({ opacity: 0, right: 0, top: 0, position: 'absolute', transform: 'translateX(-100%)' }),
                animate(300, style({ opacity: 1, right: 0, top: 0, position: 'absolute', transform: 'translateX(0%)' }))
            ]),
            transition('horz-reverse => void', [
                style({ opacity: 1, right: 0, top: 0, position: 'absolute', transform: 'translateX(0%)' }),
                animate(300, style({ opacity: 0, right: 0, top: 0, position: 'absolute', transform: 'translateX(100%)' }))
            ]),
            transition('void => vert', [
                style({ opacity: 0, left: 0, top: 0, position: 'absolute', transform: 'translateY(100%)' }),
                animate(300, style({ opacity: 1, left: 0, top: 0, position: 'absolute', transform: 'translateY(0%)' }))
            ]),
            transition('vert => void', [
                style({ opacity: 1, left: 0, top: 0, position: 'absolute', transform: 'translateY(0%)' }),
                animate(300, style({ opacity: 0, left: 0, top: 0, position: 'absolute', transform: 'translateY(-100%)' }))
            ]),
            transition('void => vert-reverse', [
                style({ opacity: 0, left: 0, top: 0, position: 'absolute', transform: 'translateY(-100%)' }),
                animate(300, style({ opacity: 1, left: 0, top: 0, position: 'absolute', transform: 'translateY(0%)' }))
            ]),
            transition('vert-reverse => void', [
                style({ opacity: 1, left: 0, top: 0, position: 'absolute', transform: 'translateY(0%)' }),
                animate(300, style({ opacity: 0, left: 0, top: 0, position: 'absolute', transform: 'translateY(100%)' }))
            ]),
        ])
    ]
})
export class StepperStepComponent extends BaseWidgetComponent {
    @Input() public heading = '';
    @Input() public state = '';
    @Output() public stateChange = new EventEmitter();

    public parent: StepperComponent = null;
    public model: { [name: string]: any } = {};

    constructor() {
        super();
        this.model.direction = 'horz';
    }

    public setActive(state: boolean) {
        if (this.state && this.state !== 'active') {
            this.model.state = this.state;
        }
        this.state = state ? 'active' : this.model.state;
    }
}
